import script from "./OrganicRankingOnPaidImpressions.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganicRankingOnPaidImpressions.vue?vue&type=script&setup=true&lang=js"

import "./OrganicRankingOnPaidImpressions.vue?vue&type=style&index=0&id=5998b1a5&lang=css"

const __exports__ = script;

export default __exports__